import { StoryblokComponent } from '@storyblok/react';

import { useMobileView } from 'apps/urban/hooks/useMobileView';
import { getSpacingFromStory } from 'apps/urban/utils/getSpacingFromStory';
import Image from 'next/image';

import { patchedStoryblokEditable } from '../../utils/patchedStoryblokEditable';
import {
  USPOverlayContentWrapper,
  USPOverlayImageShadow,
  USPOverlayImageWrapper,
  USPOverlayWrapper,
} from './USPOverlay.style';
import { USPOverlayProps } from './USPOverlay.types';

export const USPOverlay = ({ blok }: USPOverlayProps) => {
  const {
    image,
    mobileImage,
    imagePosition,
    imageSize,
    imageSpaceRight,
    imageSpaceLeft,
    objectFit,
    uspComponent,
    dotDescription,
    enableImageShadow,
    dotPositionMobile,
    dotPosition,
    flexDirectionMobile,
    gapMobile,
    hideImageOnMobile,
  } = blok;

  const { isMobile } = useMobileView();

  if (!image || !uspComponent.length) {
    return null;
  }

  // according to the designs and components specs
  // https://www.figma.com/design/L5UzEL9qFUtxqP9urXyyBr/Urban?node-id=1713-8036
  // https://www.figma.com/design/wqjncpdbzCc26UKvacUtLV/Web-app?node-id=15378-247&t=AIewJ9gjGIa5JkkJ-0
  const imageHeights: Record<string, number> = {
    small: 649,
    large: 833,
    'extra-large': 1015,
  };

  const imageHeight = imageHeights[imageSize] ?? imageHeights.large;

  const gapMobileSpacing = getSpacingFromStory(gapMobile);

  return (
    <USPOverlayWrapper {...patchedStoryblokEditable(blok)}>
      <USPOverlayContentWrapper
        imagePosition={imagePosition}
        flexDirectionMobile={flexDirectionMobile}
        gapMobileSpacing={gapMobileSpacing}
      >
        <USPOverlayImageWrapper
          imageSpaceRight={imageSpaceRight}
          imageSpaceLeft={imageSpaceLeft}
          dotPosition={dotPosition}
          dotPositionMobile={dotPositionMobile}
          hideImageOnMobile={hideImageOnMobile}
        >
          <Image
            src={isMobile && mobileImage?.filename ? mobileImage?.filename : image.filename}
            alt={image.alt}
            width={785}
            height={imageHeight}
            objectFit={objectFit ? objectFit : 'cover'}
            quality={100}
            className="USPOverlay-Image"
          />
          {enableImageShadow && <USPOverlayImageShadow />}
          {!!dotDescription.length && (
            <StoryblokComponent blok={dotDescription[0]} className="USPOverlay-DotDescription" />
          )}
        </USPOverlayImageWrapper>
        <StoryblokComponent blok={uspComponent[0]} className="USPOverlay-USPComponent" />
      </USPOverlayContentWrapper>
    </USPOverlayWrapper>
  );
};
